import { AbstractControl } from '@angular/forms';
import { DatasourceService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { map } from 'rxjs/operators';

export class VehicleInventoryValidator {

  static createValidator(id: number, service: DatasourceService) {
    
    return (control: AbstractControl) => {
    
        let state : State = {
            skip: 0, 
            take: 0, 
            sort: [], 
            filter: {
                logic: "and",
                filters: [
                    {
                        field: 'id',
                        operator: 'neq',
                        value: id
                    },
                    {
                        field: 'sku_exp',
                        operator: 'eq',
                        value: control.value
                    }
                ]
            }, 
            group: []
        }

        return service.get('vehicles_inventories', state)
            .pipe(
                map(res => {    
                    console.log('res =>', res)
                    let data: any = res;
                    return (data.total) ? { ExistsVehicleInventory: true } : null;
                })
            );

    };

  }

}